// The FD and BD of the PWA Kit may have different ways of importing/exporting constants/functions.
// An example of this is the case of the 'react-intl' library. This library is imported in the PWA Kit
// as a function, while in the BD it is imported as an object.
// As result of this, we must have a unique constants file for all files that are linked to the SSR.

import packageJson from '../../../package.json'

export const PAYMENT_METHODS = {
    ADYEN_COMPONENT: 'AdyenComponent',
    CREDIT_CARD: 'CREDIT_CARD'
}

export const PAYMENT_METHOD_TYPES = {
    CREDIT_CARD: 'scheme',
    GIFT_CARD: 'giftcard',
    WECHATPAY_MINI_PROGRAM: 'wechatpayMiniProgram',
    WECHATPAY_QR: 'wechatpayQR',
    WECHATPAY_SDK: 'wechatpaySDK',
    IDEAL: 'ideal',
    APPLEPAY: 'applepay',
    PAYPAL: 'paypal'
}

export const PAYMENT_TYPES = {
    EXPRESS: 'express',
    EXPRESS_PDP: 'expressPDP'
}

export const RESULT_CODES = {
    AUTHORISED: 'Authorised',
    CANCELLED: 'Cancelled',
    CHALLENGE_SHOPPER: 'ChallengeShopper',
    ERROR: 'Error',
    IDENTIFY_SHOPPER: 'IdentifyShopper',
    PENDING: 'Pending',
    PRESENT_TO_SHOPPER: 'PresentToShopper',
    RECEIVED: 'Received',
    REDIRECT_SHOPPER: 'RedirectShopper',
    REFUSED: 'Refused'
}

export const BLOCKED_PAYMENT_METHODS = [
    PAYMENT_METHOD_TYPES.GIFT_CARD,
    PAYMENT_METHOD_TYPES.WECHATPAY_MINI_PROGRAM,
    PAYMENT_METHOD_TYPES.WECHATPAY_QR,
    PAYMENT_METHOD_TYPES.WECHATPAY_SDK,
    PAYMENT_METHOD_TYPES.IDEAL
]

export const ADYEN_BLOCKED_PAYMENT_METHODS = [
    'bcmc_mobile_QR',
    'alipay_wap',
    'wechatpayMiniProgram',
    'wechatpaySDK',
    'wechatpayWeb'
]

export const EXPRESS_PAYMENT_METHODS = [PAYMENT_METHOD_TYPES.APPLEPAY, PAYMENT_METHOD_TYPES.PAYPAL]

export const SHOPPER_INTERACTIONS = {
    CONT_AUTH: 'ContAuth',
    ECOMMERCE: 'Ecommerce'
}

export const RECURRING_PROCESSING_MODEL = {
    CARD_ON_FILE: 'CardOnFile'
}

export const GIFT_CARD_RESULT_CODES = {
    NOTENOUGHBALANCE: 'NotEnoughBalance',
    SUCCESS: 'Success'
					   
					   
					  
}

export const NOTIFICATION_EVENT_CODES = {
    AUTHORISATION: 'AUTHORISATION',
    CAPTURE: 'CAPTURE',
    REFUND: 'REFUND',
    CANCELLATION: 'CANCELLATION',
    ORDER_CLOSED: 'ORDER_CLOSED'
}

export const NOTIFICATION_SUCCESS = {
    TRUE: 'true',
    FALSE: 'false'
}

export const DEFAULT_SHIPMENT_ID = 'me'

export const TAXATION = {
    GROSS: 'gross',
    NET: 'net'
}

export const ORDER = Object.freeze({
    ORDER_STATUS_CREATED: 'created',
    ORDER_STATUS_NEW: 'new',
    ORDER_STATUS_COMPLETED: 'completed',
    ORDER_STATUS_CANCELED: 'cancelled',
    ORDER_STATUS_FAILED: 'failed',
    ORDER_STATUS_FAILED_REOPEN: 'failed_with_reopen',
    PAYMENT_STATUS_PAID: 'paid',
    PAYMENT_STATUS_PART_PAID: 'part_paid',
    PAYMENT_STATUS_NOT_PAID: 'not_paid',
    EXPORT_STATUS_READY: 'ready',
    EXPORT_STATUS_FAILED: 'failed',
    EXPORT_STATUS_EXPORTED: 'exported',
    EXPORT_STATUS_NOT_EXPORTED: 'not_exported',
    CONFIRMATION_STATUS_CONFIRMED: 'confirmed',
    CONFIRMATION_STATUS_NOT_CONFIRMED: 'not_confirmed'
})

export const ERROR_MESSAGE = {
    AMOUNT_NOT_CORRECT: 'amount not correct',
    INVALID_ORDER: 'order is invalid',
    INVALID_PARAMS: 'invalid request params',
    INVALID_BASKET: 'invalid basket',
    BASKET_NOT_CREATED: 'basket not created',
    PAYMENT_NOT_SUCCESSFUL: 'payment was not successful',
    INVALID_BILLING_ADDRESS: 'invalid billing address',
    INVALID_SHIPPING_ADDRESS: 'invalid shipping address',
    UNAUTHORIZED: 'unauthorized',
    ORDER_ALREADY_EXISTS: 'order already exists',
    ORDER_NOT_FOUND: 'order not found',
    ORDER_NUMBER_NOT_FOUND: 'order number not found on basket',
    PAYMENTS_DETAILS_NOT_SUCCESSFUL: 'payments details call not successful',
    BASKET_CHANGED: 'basket changed',
    AMOUNTS_DONT_MATCH: 'amounts do not match',
    MISSING_LIVE_PREFIX: 'missing live prefix',
    ADYEN_CONTEXT_NOT_FOUND: 'Adyen context not found',
    NO_PAYMENT_METHODS: 'no payment methods',
    ADD_PAYMENT_INSTRUMENTS: 'Failed to add payment instrument due to missing parameters',
    CUSTOMER_NOT_FOUND: 'customer not found',
    BASKET_NOT_FOUND: 'Basket not found in adyenContext',
    PSP_REFERENCE_NOT_FOUND: 'PSP reference not found in basket',
    INVALID_PAYMENT_DATA: 'Invalid payment data'
}

export const DEFAULT_EXPIRATION_TIME = 30

export const ADYEN_LIVE_REGIONS = {
    LIVE_EU: 'live',
    LIVE_APSE: 'live-apse',
    LIVE_AU: 'live-au',
    LIVE_US: 'live-us',
    LIVE_IN: 'live-in'
}

export const ADYEN_ENVIRONMENT = {
    LIVE: 'LIVE',
    TEST: 'TEST'
}

export const APPLICATION_VERSION = packageJson.version

// recaptcha score
export const RECAPTCHA_SCORE = 0.5

// recaptcha validation url
export const RECAPTCHA_VALIDATION_URL = 'https://www.google.com/recaptcha/api/siteverify'

// SEO
export const PATH_SEPARATOR = '/'
export const COLOR_ID_SEPARATOR = '-'
export const CURRENT_CATEGORY_PATH_PREFIX = 'category'
export const CATEGORY_PATH_PREFIX = 'c'
export const PRODUCT_PATH_PREFIX = 'p'
export const CURRENT_PRODUCT_PATH_PREFIX = 'product'
export const PRODUCT_SET_PATH_PREFIX = 'ps'
export const OUTLET_PATH_PREFIX = 'outlet-'
export const LEGACY_STORE_PATH = 'store-details'
export const LEGACY_CN_LOCALE_ID = 'cn'
export const EN_LOCALE_ID = 'en'

// Payment Method IDs
export const GC_PAYMENT_METHOD_ID = 'GIFT_CERTIFICATE'

// GTM Related
export const GTM_GC_PAYMENT_ID = 'gc'

// List of countries that use the RHT pricebook
export const COUNTRIES_USING_RHT_PRICEBOOK = [
    'ER',
    'ET',
    'GQ',
    'TD',
    'EG',
    'MW',
    'BF',
    'BW',
    'BJ',
    'AO',
    'ZA',
    'AE',
    'TH',
    'GM',
    'KE',
    'JO',
    'GA',
    'NE',
    'TW',
    'RE',
    'KH',
    'NZ',
    'FJ',
    'KR',
    'RW',
    'MU',
    'MA',
    'BD',
    'TG',
    'UG',
    'LK',
    'NG',
    'LS',
    'AW',
    'TZ',
    'ML',
    'VN',
    'BH',
    'IL',
    'MN',
    'BT',
    'MY',
    'OM',
    'BN',
    'QA',
    'MZ',
    'MV',
    'LA',
    'PH',
    'PK',
    'ID',
    'SA',
    'MG',
    'KW',
    'PG',
    'TK',
    'BB',
    'VU',
    'BO',
    'AI',
    'AG',
    'AR',
    'BZ',
    'BM',
    'BR',
    'VG',
    'KY',
    'CL',
    'CO',
    'CR',
    'GF',
    'DM',
    'EC',
    'DO',
    'SV',
    'GD',
    'GP',
    'GT',
    'GY',
    'HN',
    'MQ',
    'JM',
    'MS',
    'NI',
    'PA',
    'PY',
    'PE',
    'LC',
    'BL',
    'VC',
    'TT',
    'TC',
    'UY',
    'AL',
    'BA',
    'GI',
    'IS',
    'NO',
    'SM',
    'RS',
    'ZM',
    'ME',
    'HT',
    'CW',
    'AX'
]
export const DEFAULT_COMMON_PATH_OBJ = {
    isOutletSite: false,
    websiteCode: 'eu',
    language: 'en'
}
// PDP Regexes
export const PDP_REGEX_WITH_PRODUCT_PATH = /^\/(outlet-)?(\w{2})\/(\w{2})\/(product)\/([^/]+)/i
export const PDP_REGEX_WITH_CATEGORY_PATH = /^\/(outlet-)?(\w{2})\/(\w{2})\/(p)\/([^/]+)\/([^/]+)/i
export const PDP_REGEX_WITH_QUERY_PARAM =
    /^\/(outlet-)?(\w{2})\/(\w{2})\/([^/]+)\/(\w+)\.html\?dwvar_(\w+)_color=(\w+)/i
export const PDP_REGEX_WITH_WB_PREFIX =
    /^\/(outlet-)?(\w{2})\/(\w{2})\/([^/]+)\/[wW][bB]-(\w+)-(\w+)\.html(\?dwvar_[wW][bB]-(\w+)-(\w+)_color=(\w+))?/i
export const PDP_REGEX_WITH_DIGITS_EAN = /^\/(outlet-)?(\w{2})\/(\w{2})\/([^/]+)\/(\d{13})\.html$/i
export const PDP_REGEX_CANONICAL = /^\/(outlet-)?(\w{2})\/(\w{2})\/([^/]+)\/(\w+)\.html$/i
export const ORDER_CONFIRMATION_PATH =
    /^\/(outlet-)?(\w{2})\/(\w{2})\/(checkout)\/(confirmation)\/([^/]+)/i
export const ORDER_HISTORY_PATH = /^\/(outlet-)?(\w{2})\/(\w{2})\/(account)\/(orders)\/([^/]+)/i
export const ORDER_INVOICE_PATH = /^\/(outlet-)?(\w{2})\/(\w{2})\/(invoice)\/([^/]+)/i

// Refund Related
export const REFUND_BUSINESS_RESOLUTION_STEPS = [
    'Resolution steps: it depends on the refusal reason given by Adyen',
    'Not enough funds on account → see with finance, business process',
    'Not enough remaining amount on order → check in Adyen and ask IT for help if needed',
    'Refund is blocked by an action from the customer → business process',
    'Other → check the reason and in Adyen, then ask IT for help if needed'
]

export const PDP_REGEX_FOR_MASTER_PRODUCT = /^[A-Z0-9]{8}$/
export const PDP_REGEX_FOR_VARIATION_GROUP = /^[A-Z0-9]{8}-\d{3}$/
export const PDP_REGEX_FOR_VARIANT = /^\d{13}$/
